// extracted by mini-css-extract-plugin
export default {"timeSelect":"PerformanceTimeRange_timeSelect__KODu0"};